module.exports = __webpack_public_path__ + "media/landing/badge-icon-68aba4d0.png";